// @ts-nocheck

(() => {
  if (window['__bvIstGsapParallaxInitialized']) {
    return;
  }

  window['__bvIstGsapParallaxInitialized'] = true;

  /** @typedef {{ section: HTMLElement, mediaInner: HTMLElement, factor: number, setY: (value: number) => void }} ParallaxInstance */
  /** @type {Map<HTMLElement, ParallaxInstance>} */
  const instances = new Map();
  /** @type {number | null} */
  let rafId = null;

  /** @param {number} value @param {number} min @param {number} max */
  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

  /** @param {EventTarget | null} eventTarget @returns {HTMLElement | null} */
  const findSectionNode = (eventTarget) => {
    if (!eventTarget) {
      return null;
    }

    if (eventTarget instanceof HTMLElement && eventTarget.matches('[data-bv-ist]')) {
      return eventTarget;
    }

    if (eventTarget instanceof HTMLElement) {
      const section = eventTarget.querySelector('[data-bv-ist]');
      return section instanceof HTMLElement ? section : null;
    }

    return null;
  };

  const getMotionScale = () => (window.matchMedia('(max-width: 768px)').matches ? 0.7 : 1);

  const requestUpdate = () => {
    if (rafId !== null) {
      return;
    }

    rafId = window.requestAnimationFrame(() => {
      instances.forEach((instance) => {
        const rect = instance.section.getBoundingClientRect();

        if (rect.bottom < -120 || rect.top > window.innerHeight + 120) {
          return;
        }

        const sectionCenter = rect.top + (rect.height / 2);
        const viewportCenter = window.innerHeight / 2;
        const distance = sectionCenter - viewportCenter;
        const offset = clamp(distance * instance.factor * getMotionScale(), -220, 220);

        instance.setY(offset);
      });

      rafId = null;
    });
  };

  /** @param {HTMLElement | null} section */
  const unmountSection = (section) => {
    if (!section) {
      return;
    }

    const instance = instances.get(section);

    if (!instance) {
      return;
    }

    const gsapLib = window['gsap'];

    if (gsapLib && typeof gsapLib.set === 'function') {
      gsapLib.set(instance.mediaInner, { clearProps: 'transform' });
    } else {
      instance.mediaInner.style.transform = '';
    }

    section.removeAttribute('data-bv-ist-parallax-initialized');
    instances.delete(section);
  };

  /** @param {HTMLElement | null} section */
  const mountSection = (section) => {
    if (!section || section.hasAttribute('data-bv-ist-parallax-initialized')) {
      return;
    }

    const mediaNode = section.querySelector('[data-bv-ist-media]');

    if (!(mediaNode instanceof HTMLElement)) {
      return;
    }

    const media = mediaNode;
    const mediaInnerNode = media.querySelector('[data-bv-ist-media-inner]');

    if (!(mediaInnerNode instanceof HTMLElement)) {
      return;
    }

    const mediaInner = mediaInnerNode;

    const rawSpeed = Number.parseFloat(media.dataset.parallaxSpeed || '-14');
    const speed = Number.isNaN(rawSpeed) ? -14 : rawSpeed;
    const factor = clamp(speed / 55, -0.55, 0.55);
    const gsapLib = window['gsap'];

    if (gsapLib && typeof gsapLib.set === 'function') {
      gsapLib.set(mediaInner, { scale: 1.08 });
    }

    const setY = gsapLib && typeof gsapLib.quickTo === 'function'
      ? gsapLib.quickTo(mediaInner, 'y', { duration: 0.2, ease: 'power2.out' })
      : (value) => {
        mediaInner.style.transform = `translate3d(0, ${value.toFixed(2)}px, 0) scale(1.08)`;
      };

    instances.set(section, {
      section,
      mediaInner,
      factor,
      setY,
    });

    section.setAttribute('data-bv-ist-parallax-initialized', 'true');
    requestUpdate();
  };

  const initAllSections = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    document.querySelectorAll('[data-bv-ist]').forEach((section) => {
      if (section instanceof HTMLElement) {
        mountSection(section);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections, { once: true });
  } else {
    initAllSections();
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);

  document.addEventListener('shopify:section:load', (event) => {
    const section = findSectionNode(event.target);

    if (!section) {
      return;
    }

    unmountSection(section);
    mountSection(section);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = findSectionNode(event.target);

    if (!section) {
      return;
    }

    unmountSection(section);
  });
})();
